// Owner
export const owner = {
    computed: {
        owners() {
            return this.$store.getters.getOwner.map(owner => {
                return {
                    id: owner.id,
                    value: owner.full_name
                }
            })
        }
    },

    mounted() {
        this.$store.dispatch('getOwner')
    }
}

// Pay Filter
export const pay = {
   computed: {
        pays() {
            return this.$store.getters.getPay.map(pay => {
                return {
                    id: pay.id,
                    value: pay.name
                }
            })
        }
    },


	watch: {
        'pays.length': {
            handler: function (length) {
                this.filters.find(({key, option}) => {
                    if (key === 'pay_is') option.push(...this.pays)
                })
            },
            immediate: true
        }
    },

    mounted() {

        setTimeout(()=>{
          this.$store.dispatch('getPay')
        },1000)
    }
}

// Age Filter
export const age = {
   computed: {
        ages() {
            return this.$store.getters.getAge.map(age => {
                return {
                    id: age.id,
                    value: age.name
                }
            })
        }
    },


	watch: {
        'ages.length': {
            handler: function (length) {
                this.filters.find(({key, option}) => {
                    if (key === 'age_is') option.push(...this.ages)
                })
            },
            immediate: true
        }
    },

    mounted() {

        setTimeout(()=>{
          this.$store.dispatch('getAge')
        },1000)
    }
}

// Sex Filter
export const sex = {
   computed: {
        sexs() {
            return this.$store.getters.getSex.map(sex => {
                return {
                    id: sex.id,
                    value: sex.name
                }
            })
        }
    },


	watch: {
        'sexs.length': {
            handler: function (length) {
                this.filters.find(({key, option}) => {
                    if (key === 'sex_is') option.push(...this.sexs)
                })
            },
            immediate: true
        }
    },

    mounted() {

        setTimeout(()=>{
          this.$store.dispatch('getSex')
        },1000)
    }
}

// Traf Filter
export const traf = {
   computed: {
        trafs() {
            return this.$store.getters.getTraf.map(traf => {
                return {
                    id: traf.id,
                    value: traf.name
                }
            })
        }
    },


	watch: {
        'trafs.length': {
            handler: function (length) {
                this.filters.find(({key, option}) => {
                    if (key === 'traf_is') option.push(...this.trafs)
                })
            },
            immediate: true
        }
    },

    mounted() {

        setTimeout(()=>{
          this.$store.dispatch('getTraf')
        },1000)
    }
}

// Status Filter
export const status = {

    /*
    * set two data property component
    * typeWiseStatues:[],
      statusType:"your required status type",

    * */
    data(){
      return{
          statusType: 'deal'
      }
    },
    computed: {
        statuses() {
            return this.$store.getters.getStatus.map(status => {
                return {
                    id: Number(status.id),
                    value: status.translated_name,
                    type: status.type
                }
            });
        }
    },
    watch: {
        'statuses.length': {
            handler: function (length) {
                this.typeWiseStatues.push(...this.statuses.filter(element => element.type === this.statusType));
            },
            immediate: true
        }
    },
    mounted() {
        this.$store.dispatch('getStatus')
    }
}


//Pipeline
export const pipeline = {
    computed: {
        pipelines() {
            return this.$store.getters.getPipeline.map(pipeline => {
                return {
                    id: pipeline.id,
                    value: pipeline.name
                }
            })
        }
    },
    watch: {
        'pipelines.length': {
            handler: function (length) {
                this.filters.find(({key, option}) => {
                    if (key === 'pipeline') option.push(...this.pipelines)
                })
            },
            immediate: true
        }
    },
    mounted() {
        this.$store.dispatch('getPipeline')
    }
}
export const pipelinesbymuseum = {
    computed: {
        pipelinesbymuseum() {
            return this.$store.getters.getPipelineListByMuseum.map(pipeline => {
                return {
                    id: pipeline.id,
                    value: pipeline.name
                }
            })
        }
    },
    watch: {
        'pipelines.length': {
            handler: function (length) {
                this.filters.find(({key, option}) => {
                    if (key === 'pipeline') option.push(...this.pipelinesbymuseum)
                })
            },
            immediate: true
        }
    },
    mounted() {
        this.$store.dispatch('getPipelineListByMuseum')
    }
}

//Stages
export const instage = {
    computed: {
        instages() {
            return this.$store.getters.getStages.map(instage => {
                return {
                    id: instage.id,
                    value: instage.name
                }
            })
        }
    },
    watch: {
        'instages.length': {
            handler: function (length) {
                this.filters.find(({key, option}) => {
                    if (key === 'instage_is') option.push(...this.instages)
                })
            },
            immediate: true
        }
    },
    mounted() {
        this.$store.dispatch('getStages')
    }
}




// Stage
export const stages = {

    computed: {
        stages() {
            return this.$store.getters.getStages.map(stage => {
                return {
                    id: stage.id,
                    value: stage.name,
                    pipeline_id: stage.pipeline_id
                }
            })
        }
    },

    watch: {
        'stages': {
            handler: function (length) {

                let indexOfStageFilter = this.secondaryFilters.findIndex(element => element.key === "stages");
				
				
                this.secondaryFilters.find(({key, option, pip}) => {
					
                    //get only stages for pipeline_id 1
                    let filteredStages = this.stages.filter((element) => {
                        return element.pipeline_id === pip;
                    });


                    if (key === 'stages') {
                        let isDuplicate = filteredStages.includes(
                            {
                                id: 0,
                                value: this.$t('every_stage'),
                                pipeline_id: 1
                            }
                        );

                        !isDuplicate ? filteredStages.unshift(
                            {
                                id: 0,
                                value: this.$t('every_stage'),
                                pipeline_id: 1
                            }) : false;

                        this.secondaryFilters[indexOfStageFilter].option = filteredStages;
                        this.secondaryFilters[indexOfStageFilter].title = this.$t('every_stage');
                        this.secondaryFilters[indexOfStageFilter].option = filteredStages;
                    }
                })
            },
            immediate: true
        }
    },
    mounted() {
        this.$store.dispatch('getStages');
    }
}
